module.exports = __webpack_public_path__ + "static/media/aboutUs.9650df61.jpg";